import { useRecordContext } from "react-admin";
import { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { isStudent, Student } from "../../providers/studentsProvider";
import { SlideUp } from "../SlideUp";
import { DialogCloseButton } from "../DialogCloseButton";
import { type DialogProps } from "../DialogProps";
import { type DrivingLesson, PracticalExam, TheoryExam } from "../../model/autovioCalendarEvents";
import { formatMoney } from "../Money";
import LoadingButton from "@mui/lab/LoadingButton";
import { runSafelyWithServerClient } from "../../api/server.api";

export function TriggerPaymentDialog(props: { event: TheoryExam | DrivingLesson | PracticalExam } & DialogProps) {
  const { event, open, onClose } = props;
  const student = useRecordContext<Student>();
  const [isLoading, setIsLoading] = useState(false);

  const triggerPayment = async () => {
    setIsLoading(true);
    await runSafelyWithServerClient(
      (serverClient) => serverClient.triggerPayment(undefined, { params: { id: event.id } }),
      {
        successMessage: "Die Bezahlung wurde erfolgreich ausgelöst.",
        errorMessage: "Fehler beim Auslösen der Bezahlung.",
        onSuccess: onClose,
      },
    );
    setIsLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} TransitionComponent={SlideUp}>
      <DialogTitle>Bezahlung auslösen</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        {`${isStudent(student) && student.gender === "Female" ? "Der Fahrschülerin" : "Dem Fahrschüler"} werden `}
        <b>{formatMoney(event.price)}</b>
        {" sofort in Rechnung gestellt."}
      </DialogContent>
      <DialogActions>
        <LoadingButton variant="contained" loading={isLoading} onClick={triggerPayment}>
          Bezahlung auslösen
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
